<div class="content flex align-items-center justify-content-between py-3 px-4 border-round-lg" 
[style.background-color]="bgColor" [style.border-color]="!disableBorder ? borderColor : 'transparent'" [style.width]="width">
  <div class="flex flex-column align-items-start">
    <span [style.color]="borderColor" [innerHTML]="label">
    </span>
    <span [style.color]="borderColor" class="title mr-3">
    {{ value | currency:'BRL':'symbol':'1.2-2'  }}
    </span>
  </div>
  <div *ngIf="tooltipMessage || tooltipMessage.length > 0">
    <i class="pi pi-info-circle text-2xl cursor-pointer opacity-50" [style.color]="borderColor" pTooltip [pTooltip]="tooltipMessage" tooltipPosition="top"></i>
  </div>
</div>
